/*
 * @Author: ttheitao
 * @Date: 2024-03-29 10:38:50
 * @Description: some description
 * @LastEditors: ttheitao
 * @LastEditTime: 2024-06-26 10:52:05
 */
/* eslint-disable */

import { IKeyValue } from "@/lib/IType";
import http from "@/lib/http";
const urlPrefix = 'onetab/';


/**
 * @description: 登录
 * @param {IKeyValue} data {email:'',code:111}
 * @return {*}
 */
export const login = (data: IKeyValue) => {
  return http.post(`${urlPrefix}login`, data);
}

/**
 * @description: 发送登录验证码
 * @param {*} email
 * @return {*}
 */
export const sendLoginCode = (email) => {
  return http.post(`${urlPrefix}sendLoginCode`, { email });
}

export const vipinfo = () => {
  return http.get(`${urlPrefix}user/vipinfo`);
}

export const vipBuy = (data: IKeyValue) => {
  return http.post(`${urlPrefix}vip/buy`, data);
}

export const wechatPay = (data: IKeyValue) => {
  return http.post(`${urlPrefix}vip/wechatPay`, data, {
    responseType: 'text',
  });
}

export const queryOrder = (data: IKeyValue) => {
  return http.get(`${urlPrefix}vip/queryOrders`, {
    params: data,
  });
}
